export default __webpack_public_path__ + "static/media/ai.a1b02c9a.svg";